import { Data, TransformsList } from 'cio/utils/analytics/transforms';
import { generateSource } from 'cio/utils/analytics/sources';

const Transforms: TransformsList = {
  passwordError(data) {
    return {
      'Password Failed Requirements Because': data.error,
      'Password Failed Requirements During': data.errorDuring,
    };
  },

  helpDocsView(data) {
    return {
      'Document URL': data.href,
      Source: generateSource(data),
    };
  },

  chooseUserListViewed(data: { usersCount: number }) {
    return {
      'Users Count': data.usersCount,
    };
  },

  errorEncountered(data: Data & { message: string | string[] }) {
    return {
      Message: data.message,
      'Current URL': data.currentUrl,
      Source: data.source,
    };
  },

  feedbackRequestStarted(data) {
    return {
      Source: data.source,
    };
  },

  forgotPasswordClicked(data) {
    return {
      Source: data.source,
    };
  },

  reauthenticated(data) {
    return {
      Method: data.method,
    };
  },

  gotSessionExpirationCookieRemoved(data) {
    return {
      'Account Id': data.accountId,
      Reason: data.reason,
    };
  },
  gotSessionExpirationTimestamp(data) {
    return {
      'Account Id': data.accountId,
    };
  },
  gotSessionExpirationCookieSet(data) {
    return {
      'Account Id': data.accountId,
    };
  },
};

export default Transforms;
